import { useState, useEffect, useRef } from "react";
import { Box, TextField, FormControl, Autocomplete, Divider, Button, MenuItem, Typography, Grid, FormControlLabel, Checkbox, InputLabel, Select } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { Toolbar, } from '@mui/material';
import Header from "../../../Layout/Header";
import CallAlertBar from "../../../Layout/Alertbar";

import { Today } from "@mui/icons-material";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";

const LeaveRequestForm = ({ handleBackWinderMachineEntry, SelectedEmployeeleaveRequests }) => {

    const [leaveType, setLeaveType] = useState("");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [reason, setReason] = useState("");
    const [employee, setEmployee] = useState('');
    const [employeelist, setEmployeelist] = useState([]);
    const [employeeleavetype, setEmployeeleavetype] = useState([]);
    const [employeeID, setEmployeeID] = useState("");
    const [leaveTypeID, setLeaveTypeID] = useState("");
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('Welcome to Paper Roll Booking! ');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');
    const [errorMessages, setErrorMessages] = useState({});
    const [disabledEmployeeDetails, setdisabledEmployeeDetails] = useState(false);
    const [ApprovalButton, setApprovalButton] = useState(false);
    const [EnableRejectResonInput, setEnableRejectResonInput] = useState(false);
    const [RejectedReason, setRejectedReason] = useState("");
    const inputRef = useRef(null); // Create a reference
    const [remainingLeave, setremainingLeave] = useState(0);
    const [isHalfDay, setIsHalfDay] = useState(false);
    const [halfDayType, setHalfDayType] = useState('');
    const [isHourPermission, setIsHourPermission] = useState(false);
    const [selectedHour, setSelectedHour] = useState('');
    const [Error, setError] = useState('');



    const ViewHideMsg = (msg, securityvalue, open) => {
        setParentRollSeverityvalue(securityvalue);
        setParentRollMessageValue(msg);
        setParentRollAlertTitleValue(securityvalue);
        setParentRollMsgOpen(open);
    }

    const validateEmployeeLeaveRequest = () => {

        const errors = {};
        if (!employeeID) {
            ViewHideMsg("Employee is required.", 'warning', true);
            errors.employeeID = "Employee is required.";

        } else if (!leaveTypeID) {
            ViewHideMsg("Leave type is required.", 'warning', true);
            errors.leaveTypeID = "Leave type is required.";
        }
        else if (!reason) {
            ViewHideMsg("Leave reason is required.", 'warning', true);
            errors.leaveTypeID = "Leave reason is required.";
        }
        else if (!startDate) {
            ViewHideMsg("Start date is required.", 'warning', true);
            errors.startDate = "Start date is required.";
        }
        else if (!endDate) {
            ViewHideMsg("End date is required.", 'warning', true);
            errors.endDate = "End date is required.";
        }
        else if (startDate > endDate) {
            ViewHideMsg("Start date should be less than to End date.", 'warning', true);
            errors.timeComparison = "Start date should be less than to End date.";
        }
        else if (startDate < Today) {
            ViewHideMsg("Leave start date cannot be in the past.", 'warning', true);
            errors.timeComparison = "Leave start date cannot be in the past.";
        }

        return errors;
    };

    const handleSubmit = async () => {

        const errors = validateEmployeeLeaveRequest();

        if (Object.keys(errors).length > 0) {
            setErrorMessages(errors);
            return;
        }
        const params = {
            id_employee: employeeID,
            id_leave_type: leaveTypeID,
            leave_start_date: dayjs(startDate).format("YYYY-MM-DD"),  // corrected to standard format
            leave_end_date: dayjs(endDate).format("YYYY-MM-DD"),
            leave_reason: reason,
            is_half_day: isHalfDay,                      // new boolean value from your form
            half_day_type: isHalfDay ? halfDayType : null, // string: 'FIRST_HALF' or 'SECOND_HALF'
            is_hour_permission: isHourPermission,
            number_of_hours: selectedHour
        };

        callApi(API_ENDPOINTS.EMPLOYEE_InsertEmployeeLeaveRequest, 'POST', { 'Content-Type': 'application/json' }, params)
            .then(data => {
                if (data?.length) {

                    if (data === 'Leave request submitted successfully!') {
                        ViewHideMsg("Leave request submitted successfully!", 'success', true);
                    }
                    else {
                        ViewHideMsg(data, 'warning', true);
                    }
                }
            })
            .catch(error => alert(error.message));

    };

    const handleEmployeeChange = (event, value) => {
        if (value) {
            setEmployee(value);
            setEmployeeID(value.id);
        }
        else {
            setEmployee('');
            setEmployeeID('');
        }
    }


    const handleEmployeeLeaveTypeChange = (event, value) => {
        if (value) {
            setLeaveType(value);
            setLeaveTypeID(value.id);
        }
        else {
            setLeaveType('');
            setLeaveTypeID('');
        }
    }

    useEffect(() => {
        const params = { p_companyid: localStorage.getItem('companyid') };

        callApi(API_ENDPOINTS.EMPLOYEE_GetEmployeeLists, 'POST', { 'Content-Type': 'application/json' }, params)
            .then(data => {
                if (data?.length) {
                    setEmployeelist(data);
                }
            })
            .catch(error => alert(error.message));

        callApi(API_ENDPOINTS.EMPLOYEE_LEAVE_TYPE, 'POST', { 'Content-Type': 'application/json' }, params)
            .then(data => {
                if (data?.length) {
                    setEmployeeleavetype(data);
                }
            })
            .catch(error => alert(error.message));


    }, []);

    useEffect(() => {

        if (SelectedEmployeeleaveRequests && employeelist.length > 0 && employeeleavetype.length > 0) {
            const EmployeeDetails = employeelist.find(user => user.name === SelectedEmployeeleaveRequests.employee_fullname);
            setEmployee(EmployeeDetails);

            const EmployeeLeaveType = employeeleavetype.find(user => user.leavetype === SelectedEmployeeleaveRequests.leave_type);
            setLeaveType(EmployeeLeaveType);

            setEmployeeID(EmployeeDetails.id);
            setLeaveTypeID(EmployeeLeaveType.id);
            setIsHalfDay(SelectedEmployeeleaveRequests.is_half_day);
            setHalfDayType(SelectedEmployeeleaveRequests.half_day_type);
            setIsHourPermission(SelectedEmployeeleaveRequests.is_hour_permission);
            setSelectedHour(SelectedEmployeeleaveRequests.number_of_hours);

            setStartDate(dayjs(SelectedEmployeeleaveRequests.leave_start_date));
            setEndDate(dayjs(SelectedEmployeeleaveRequests.leave_end_date));
            setReason(SelectedEmployeeleaveRequests.leave_reason);
            setApprovalButton(true);
            setdisabledEmployeeDetails(true);

            if (SelectedEmployeeleaveRequests.approval_status === 'Rejected') {
                setEnableRejectResonInput(true);
                setRejectedReason(SelectedEmployeeleaveRequests.rejected_reason);
            }

            setremainingLeave(SelectedEmployeeleaveRequests.leave_balance)

        }

    }, [employeelist, employeeleavetype, SelectedEmployeeleaveRequests]);



    const ClearAll = async () => {
        // Assuming you might have asynchronous operations in the future
        try {
            setEmployee('');
            setEmployeeID('');
            setLeaveType('');
            setLeaveTypeID('');
            setStartDate(null);
            setEndDate(null);
            setReason('');
            setParentRollMsgOpen(false);
        } catch (error) {
            console.error('Error during ClearAll:', error);

        }
    };

    const handleAction = async (id, status) => {
        // Show a confirmation prompt
        if (status === 'Rejected' && !RejectedReason) {
            setEnableRejectResonInput(true);
            ViewHideMsg('Please Enter the Rejected Reason', 'info', true);          
            setTimeout(() => inputRef.current?.focus(), 0);  // Focus the input field
            return;
        }

        if (status === 'Approved') {
            setEnableRejectResonInput(false);
        }

        const confirmation = window.confirm(`Are you sure you want to ${status.toLowerCase()} this leave request?`);

        if (!confirmation) {
            // If the user cancels, do nothing
            return;
        }

        const managerId = localStorage.getItem('userID');

        const params = {
            id: id,
            approval_status: status,
            approved_by: managerId,
            rejected_reason: RejectedReason
        };

        callApi(API_ENDPOINTS.EMPLOYEE_UpdateEmployeeLeaveRequestStatus, 'POST', { 'Content-Type': 'application/json' }, params)
            .then(data => {
                if (data?.length) {

                    if (!isNaN(data)) {
                        // If data is a number
                        ViewHideMsg('Leave request status updated successfully!', 'success', true);
                        setremainingLeave(data);
                        handleBackWinderMachineEntry();

                    } else {
                        // If data is not a number
                        ViewHideMsg(data, 'warning', true);
                    }

                }
            })
            .catch(error => alert(error.message));

    };

  
    const calculateLeaveDuration = (start, end, isHalfDay, halfDayType, isHourPermission, selectedHour) => {
        if (!start || (!end && !isHalfDay && !isHourPermission)) return "";

        if (isHourPermission && selectedHour)
            return `${selectedHour} Hour(s)`;

        if (isHalfDay)
            return `0.5 Day (${halfDayType || "Select Half"})`;

        const startDate = new Date(start);
        const endDateVal = new Date(end);
        const timeDiff = endDateVal.getTime() - startDate.getTime();
        const dayDiff = Math.floor(timeDiff / (1000 * 3600 * 24)) + 1;
        return `${dayDiff} Day(s)`;
    };


    useEffect(() => {
        if (leaveType?.leavetype === "Casual Leave" && startDate && endDate) {
            const diffDays = dayjs(endDate).diff(dayjs(startDate), 'day') + 1;
            if (diffDays > 4) {
                setError("Casual leave cannot exceed 4 consecutive days.");
            }
        }

        if (leaveType?.leavetype === "Yearly Leave" && leaveType?.availedCount >= 3) {
            setError("Yearly leave can only be taken 3 times per year.");
        }

        if (leaveType?.leavetype === "Maternity Leave" && employee?.gender !== "Female") {
            setError("Maternity Leave is only available for female employees.");
        }

        if (leaveType?.leavetype === "Paternity Leave" && employee?.gender !== "Male") {
            setError("Paternity Leave is only available for male employees.");
        }
    }, [leaveType, startDate, endDate]);

    return (
        <Box padding={0}>
            <Header title={'Leave Request Form'} subtitle='' callback={handleBackWinderMachineEntry} />
            <Divider />
            {/* Message box detail */}
            <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />



            <Grid container spacing={2} padding={3}>


                <Grid container padding="10px 0px 20px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">

                    <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                        <Typography variant="h6">Employee Name</Typography>
                    </Grid>
                    <Grid item xs={12} sm={11} md={4.1} lg={4.1} xl={4.1}>
                        <Autocomplete
                            fullWidth
                            value={employee}
                            onChange={handleEmployeeChange}
                            size="small"
                            style={{ fontSize: '12px' }}
                            options={employeelist}
                            getOptionLabel={(option) => option?.name || ''}
                            disabled={disabledEmployeeDetails}
                            renderInput={(params) =>
                                <TextField required
                                    disabled={disabledEmployeeDetails}

                                    {...params} variant="outlined" />}
                        />
                    </Grid>
                    {disabledEmployeeDetails && (
                        <Grid item xs={12} sm={12} md={1.5} lg={2} xl={2} display="flex-start" justifyContent="center">
                            <Box
                                sx={{
                                    display: "inline-block",
                                    padding: "0.5rem 1rem",
                                    backgroundColor: "#f0f4ff", // Light blue background
                                    borderRadius: "8px", // Rounded corners
                                    border: "1px solid #d1e4ff", // Optional border for emphasis
                                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)", // Subtle shadow
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    sx={{ color: "#1e88e5", fontWeight: "bold" }} // Highlight text color
                                >
                                    Remaining Leave: {remainingLeave}
                                </Typography>
                            </Box>

                        </Grid>
                    )}

                </Grid>


                <Grid container padding="10px 0px 20px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                    <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                        <Typography variant="h6">Leave Type</Typography>
                    </Grid>
                    <Grid item xs={12} sm={11} md={4.1} lg={4.1} xl={4.1}>
                        <Autocomplete
                            fullWidth
                            value={leaveType}
                            onChange={handleEmployeeLeaveTypeChange}
                            size="small"
                            style={{ fontSize: '12px' }}
                            options={employeeleavetype}
                            getOptionLabel={(option) => option?.leavetype || ''}
                            disabled={disabledEmployeeDetails}
                            renderInput={(params) =>
                                <TextField required
                                    disabled={disabledEmployeeDetails}
                                    // helperText={errorMessage}
                                    // error={errorMessage && errorMessage.length ? true : false}
                                    {...params} variant="outlined" />}
                        />
                        {leaveType && (
                            <Typography variant="body2" color="textSecondary" sx={{ ml: 2, mt: 1 }}>
                                {leaveType.leavetype === "Casual Leave" && "Max 4 consecutive days allowed."}
                                {leaveType.leavetype === "Yearly Leave" && "Allowed max 3 times per year."}
                                {leaveType.leavetype === "Sick Leave" && "Medical certificate may be required."}
                                {leaveType.leavetype === "Maternity Leave" && "Up to 26 weeks for female employees."}
                            </Typography>
                        )}
                    </Grid>
                </Grid>


                {/* Half Day Checkbox */}
                <Grid container padding="5px 0px 20px 20px" spacing={2} alignItems="center">
                    <Grid item md={1.5}><Typography variant="h6">Half Day</Typography></Grid>
                    <Grid item md={4.1}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={isHalfDay}
                                    color="secondary"
                                    onChange={(e) => {
                                        setIsHalfDay(e.target.checked);
                                        if (!e.target.checked) {
                                            setHalfDayType('');
                                            setEndDate(null); // optional
                                        } else {
                                            setEndDate(startDate); // optional: set end = start
                                        }
                                    }}
                                    disabled={disabledEmployeeDetails}
                                />
                            }
                            label="Apply for Half Day Leave"
                        />
                    </Grid>
                </Grid>

                {/* First/Second Half Selector */}
                {isHalfDay && (
                    <Grid container padding="5px 0px 20px 20px" spacing={2} alignItems="center">
                        <Grid item md={1.5}><Typography variant="h6">Half Day Type</Typography></Grid>
                        <Grid item md={4.1}>
                            <FormControl fullWidth size="small">
                                <InputLabel>Select Half</InputLabel>
                                <Select
                                    value={halfDayType}
                                    onChange={(e) => setHalfDayType(e.target.value)}
                                    label="Select Half"
                                    disabled={disabledEmployeeDetails}
                                >
                                    <MenuItem value="FIRST_HALF">First Half</MenuItem>
                                    <MenuItem value="SECOND_HALF">Second Half</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                )}

                {/* Hour Permission Checkbox */}
                <Grid container padding="5px 0px 20px 20px" spacing={2} alignItems="center">
                    <Grid item md={1.5}><Typography variant="h6">Hour Permission</Typography></Grid>
                    <Grid item md={4.1}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={isHourPermission}
                                    color="secondary"
                                    onChange={(e) => {
                                        setIsHourPermission(e.target.checked);
                                        if (e.target.checked) {
                                            setIsHalfDay(false);        // Uncheck half-day
                                            setHalfDayType('');
                                            setEndDate(startDate);      // Optional: Set same-day end
                                        } else {
                                            setSelectedHour('');
                                        }
                                    }}
                                    disabled={disabledEmployeeDetails}
                                />
                            }
                            label="Apply for Hour Permission"
                        />
                    </Grid>
                </Grid>

                {isHourPermission && (
                    <Grid container padding="5px 0px 20px 20px" spacing={2} alignItems="center">
                        <Grid item md={1.5}><Typography variant="h6">Hour(s)</Typography></Grid>
                        <Grid item md={4.1}>
                            <FormControl fullWidth size="small">
                                <InputLabel>Select Hour</InputLabel>
                                <Select
                                    value={selectedHour}
                                    onChange={(e) => setSelectedHour(e.target.value)}
                                    label="Select Hour"
                                    disabled={disabledEmployeeDetails}
                                >
                                    <MenuItem value="1">1 Hour</MenuItem>
                                    <MenuItem value="2">2 Hours</MenuItem>
                                    <MenuItem value="3">3 Hours</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                )}


                <Grid container padding="5px 0px 20px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                    <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                        <Typography variant="h6">Date range</Typography>
                    </Grid>
                    <Grid item xs={12} sm={11} md={2} lg={2} xl={2}>
                        <FormControl size="small">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    disabled={disabledEmployeeDetails}
                                    label="Start Date"
                                    value={startDate}
                                    format="DD-MMM-YYYY"
                                    onChange={(newValue) => setStartDate(newValue)}
                                    slotProps={{ textField: { size: 'small' } }}
                                    renderInput={(props) => <TextField required  {...props} fullWidth />}
                                />
                            </LocalizationProvider>
                        </FormControl>
                    </Grid>


                    <Grid item xs={12} sm={12} md={.1} lg={.1} xl={.1} display="flex-start" justifyContent="center" alignItems={"center"}>
                        <Typography variant="h6">-</Typography>
                    </Grid>


                    <Grid item xs={12} sm={11} md={2} lg={2} xl={2}>
                        <FormControl size="small">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    disabled={disabledEmployeeDetails}
                                    label="End Date"
                                    value={endDate}
                                    format="DD-MMM-YYYY"
                                    onChange={(newValue) => setEndDate(newValue)}
                                    slotProps={{ textField: { size: 'small' } }}
                                    renderInput={(props) => <TextField required {...props} fullWidth />}
                                />
                            </LocalizationProvider>
                        </FormControl>
                    </Grid>


                </Grid>

                <Grid container padding="5px 0px 20px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} alignItems="center">
                    <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                        <Typography variant="h6">Leave Duration</Typography>
                    </Grid>
                    <Grid item xs={12} sm={11} md={4.1} lg={4.1} xl={4.1}>
                        <Typography variant="h6">
                            {/* {calculateLeaveDuration(startDate, endDate)} */}
                            {calculateLeaveDuration(startDate, endDate, isHalfDay, halfDayType, isHourPermission, selectedHour)}
                        </Typography>
                    </Grid>
                </Grid>




                <Grid container padding="5px 0px 20px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} >
                    <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                        <Typography variant="h6">Reason</Typography>
                    </Grid>
                    <Grid item xs={12} sm={11} md={4.1} lg={4.1} xl={4.1}>
                        <TextField
                            disabled={disabledEmployeeDetails}
                            fullWidth
                            multiline
                            rows={4}
                            label="Enter the Reason"
                            size="small"
                            required
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                        />
                    </Grid>
                </Grid>

                {EnableRejectResonInput && (
                    <Grid container padding="5px 0px 20px 20px" spacing={{ xs: 2, sm: 2, md: 2, lg: 1, xl: 1 }} >
                        <Grid item xs={12} sm={12} md={1.5} lg={1.5} xl={1.5} display="flex-start" justifyContent="center">
                            <Typography variant="h6">Rejected Reason</Typography>
                        </Grid>
                        <Grid item xs={12} sm={11} md={4.1} lg={4.1} xl={4.1}>
                            <TextField
                                fullWidth
                                multiline
                                rows={3}
                                label="Enter the Rejected Reason"
                                size="small"
                                inputRef={inputRef} // Attach the reference
                                value={RejectedReason}
                                onChange={(e) => setRejectedReason(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                )}

            </Grid>


            <Box justifyContent={'space-between'} sx={{
                position: 'fixed',
                bottom: 0,
                width: '100%'
            }}>
                <Divider style={{ backgroundColor: '' }} />
                <Toolbar >


                    {!ApprovalButton && (
                        <>
                            <Button variant='contained' style={{ fontSize: '12px', marginRight: '8px', textTransform: 'none', backgroundColor: '#1769aa' }} onClick={handleSubmit} type="Submit">
                                Save
                            </Button>
                            <Button
                                onClick={ClearAll}
                                variant='contained'
                                style={{ marginRight: '0px', fontSize: '12px', backgroundColor: '#c5c7c6', color: 'black', textTransform: 'none', }} //borderRadius:'5px 5px 0px 5px'
                            >
                                Clear
                            </Button>
                        </>
                    )
                    }



                    {ApprovalButton && (
                        <>
                            <Button variant='outlined' color="success" size="small" startIcon={<CheckCircleOutlineIcon />} style={{ fontSize: '12px', marginRight: '8px', textTransform: 'none', }} onClick={() => handleAction(SelectedEmployeeleaveRequests.id, "Approved")}>
                                Approve
                            </Button>

                            <Button variant='outlined' color="error" size="small" startIcon={<CancelOutlinedIcon />} style={{ fontSize: '12px', marginRight: '8px', textTransform: 'none', }} onClick={() => handleAction(SelectedEmployeeleaveRequests.id, "Rejected")}>
                                Reject
                            </Button>
                        </>
                    )}
                </Toolbar>
            </Box>
        </Box>
    );
};

export default LeaveRequestForm;
